module.exports = __webpack_public_path__ + "img/bar2.d89c7cf3.svg";